import React from 'react';
import { Grid } from '../../components/grid';
import { Box, SkeletonGroup } from '@wix/design-system';
import { AppBoxSkeleton } from '../../components/app-box/app-box-skeleton';
export function AppGridSkeleton({ boxCount, columns = 4, minColumns, dataHook, skin = 'default', }) {
    return (React.createElement(Box, { width: "100%", direction: "vertical" },
        React.createElement(Grid, { dataHook: dataHook ?? 'app-grid-skeleton', columns: columns, minColumns: minColumns, skin: skin }, Array.from({ length: boxCount }).map((_value, index) => (React.createElement(SkeletonGroup, null,
            React.createElement(AppBoxSkeleton, { key: index, skin: skin })))))));
}
//# sourceMappingURL=app-grid-skeleton.js.map